<template>
  <Content id="MChatRQrCodeList">
    <div slot="search">
      <Form :label-width="50" :model="search">
        <Row>
          <Col>
            <FormItem :label-width="40" label="下载">
              <Select v-model="search.downloaded" style="width:100px;">
                <Option v-for="item in downloadedList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="测评">
              <Select v-model="search.used" style="width:100px;">
                <Option v-for="item in usedList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="来源">
              <Select v-model="search.source" style="width:100px;">
                <Option v-for="item in sourceList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width:100px;">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="生成时间" :label-width="80">
              <DatePicker  style="width:114px ;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd" v-model="search.startDate"  @on-change="changestart"></DatePicker>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd" v-model="search.endDate" @on-change="changeend"></DatePicker>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="handleDataList">搜索</Button>
            </div>
          </Col>
        </Row>
      </Form>
      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button type="primary" size="small" @click="genQRCode">生成二维码</Button>
        </div>
      </div>
    </div>

    <Table ref="list"  :columns="columns" :loading="list.loading" :data="list.data"
           highlight-row :row-class-name="tableRowClassName">
      <template slot-scope="{row}" slot="operation">
        <a @click.stop="qrcode(row)">二维码</a>&nbsp;|&nbsp;
        <a @click.stop="download(row)">下载</a>&nbsp;|&nbsp;
        <a @click.stop="del(row)">删除</a>
      </template>
    </Table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer size="small" @on-change="chagecurrent"
          :page-size-opts="[10, 20, 40, 80]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <!--二维码窗口-->
    <MChatRQrcode ref="QRCode"/>

    <Modal v-model="showGenQRCode" title="生成二维码" class-name="vertical-center-modal" :mask-closable="false">
      <div style="text-align:left" :class="{'margin-top-55': isshow}">
        生成 <el-input-number v-model="quantity" :min="1" :max="10" label="请输入生成份数"/> 个
      </div>
      <div slot="footer">
        <Button type="primary" @click="toQRCode">生成</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import {_selectPages, _download, _updateStatus, _delete, _genQrCode} from "@/services/qrcode/mChatQrCode";
import MChatRQrcode from "./mChatQrcode.vue";
import dayjs from "dayjs";
export default {
  components: {MChatRQrcode},
  inject: ['reload'],
  name: "MChatRQrCodeList",
  computed: {
    getClass() {
      const width = window.innerWidth;
      if (width < 600) {
        return 'small-screen';
      } else if (width < 1200) {
        return 'medium-screen';
      } else {
        return 'large-screen';
      }
    }
  },
  data() {
    return {
      editWindow: false,
      showGenQRCode: false,
      isshow: false,
      windowTitle: "新增",
      quantity: 1,
      search: {
        downloaded: "",
        status: 1,
        used: "",
        source: "",
        endDate:dayjs().format('YYYY-MM-DD'),
        startDate:dayjs().format('YYYY-MM-DD'),
      },
      list: {
        data: [],
        loading: false
      },
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      downloadedList: [
        {label: '全部', value: ""},
        {label: '未下载', value: 1},
        {label: '已下载', value: 2},
      ],
      usedList: [
        {label: '全部', value: ""},
        {label: '未测评', value: 1},
        {label: '已测评', value: 2},
      ],
      statusList: [
        {label: '启用', value: 1},
        {label: '禁用', value: 2},
      ],
      sourceList: [
        {label: '全部', value: ""},
        {label: '系统', value: 1},
        {label: '小程序', value: 2},
      ],
      columns: [
        {
          title: "编号",
          key: "id",
          minWidth: 80,
          fixed: "left",
          align: 'center',
        },
        {
          title: "测评",
          key: "used",
          minWidth: 60,
          render: (h, params) =>
            h('span', params.row.used === 1 ? "未测评" : "已测评")
        },
        {
          title: "下载状态",
          key: "downloaded",
          minWidth: 60,
          render: (h, params) =>
            h('span', params.row.downloaded === 1 ? "未下载" : "已下载")
        },
        {
          title: "来源",
          key: "source",
          minWidth: 60,
          render: (h, params) =>
            h('span', params.row.source === 1 ? "系统" : "小程序")
        },
        {
          title: "生成时间",
          key: "createTime",
          minWidth: 200,
        },
        {
          title: "状态",
          key: "status",
          minWidth: 60,
          render: (h, params) =>{
            return this.$Utils.operatorBtn_FORMAT(h,params,
              {
                type: 'switch',
                paramName: 'status',
                confirm: true,
                value: params.row.status,
                callback: this.handleEditStatus
              },
            )
          }
        },
        {
          title: "操作",
          slot: "operation",
          align: "center",
          fixed: "right",
          minWidth: 210
        }
      ]
    };
  },
  mounted() {
    if (!this.$userSession.checkInstitutionId()){
      return;
    }
    this.handleDataList();
  },
  methods: {
    tableRowClassName(row, rowIndex) {
      row.index = rowIndex;
      if (this.currentRowIndex === rowIndex) {
        return "success-row";
      }
    },
    handleDataList() {
      if (!this.$userSession.checkInstitutionId()){
        this.$message.warning('请先选择机构');
        return;
      }
      _selectPages({
        ...this.search,
        currentPage: this.pageList.currentPage,
        pageSize: this.pageList.pageSize
      }).then(res => {
        this.$Loading.finish();
        const {records, total} = res.data;
        this.list = {
          data: records,
          loading: false
        };
        this.pageList.total = total;
      }).catch(() => {
        this.$Loading.error();
        this.list.loading = false;
      });
    },
    download(row){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      _download({qrCodeId:row.id}).then(res => {
        if (res && res.errcode && res.errcode === 1){

        } else{
          this.$message.error(res.errmsg)
        }
      })
    },
    qrcode(row) {
      this.$refs["QRCode"].handleModal(row.id);
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.id}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(()=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else{
                this.$message.error(res.errmsg);
              }
            }).catch(() => {
              this.$Loading.error();
              this.list.loading = false;
            });
          }).catch(() => {

          }).finally(() => {
          })
        });
      }
    },
    del(row) {
      this.$confirm('是否确定删除 ' + row.name +'?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        _delete({id:row.id}).then(res=>{
          if (res && res.errcode && res.errcode === 1){
            this.handleDataList();
            this.$message.success("删除成功")
          }else{
            this.$message.error(res.errmsg)
          }
        })
      }).catch(() => {

      });
    },
    genQRCode(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.quantity = 1;
      this.showGenQRCode = true;
    },
    toQRCode(){
      _genQrCode({quantity:this.quantity}).then(res => {
        if (res && res.errcode && res.errcode === 1){
          this.handleDataList()
          this.$message.success("生成成功");
          this.showGenQRCode = false;
        } else{
          this.$message.error(res.errmsg)
        }
      })
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    changestart(e) {
      this.search.startDate = e
    },
    changeend(e) {
      this.search.endDate = e
    },
  }
};
</script>
<style lang="postcss" scoped>
.small-screen {
  height: 110vh;
}

.medium-screen {
  height: 90vh;
}

.large-screen {
  height: 70vh;
}
</style>
